import { Component, OnInit } from '@angular/core';
 
@Component({
  selector: 'app-headerhome-comparatore',
  templateUrl: './headerhome-comparatore.component.html',
  styleUrls: ['./headerhome-comparatore.component.scss']
})
export class HeaderhomeComparatoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

   

}



// WEBPACK FOOTER //
// ./src/app/headerhome-comparatore/headerhome-comparatore.component.ts